import React from "react";
import { Marker, useMap } from "react-map-gl";
import { useRecoilValue, useRecoilState } from "recoil";
import {
	travelTimeLoadingAtom,
	travelTimeRenderingAtom,
	travelTimeOptionsSelector,
} from './atoms'

export default function SpinnerLayer() {
	const mapRef = useMap()
	const options = useRecoilValue(travelTimeOptionsSelector)
	const loading = useRecoilValue(travelTimeLoadingAtom)
	const [rendering, setRendering] = useRecoilState(travelTimeRenderingAtom)
	const [coordinates, setCoordinates] = React.useState(null)
	const [enabled, setEnabled] = React.useState(false)
	const [map, setMap] = React.useState(null)

	const watchForRender = (e) => {
		setRendering(false)
	}

	const hasCoords = () => {
		const exists = (v) => !!v || v === 0
		return exists(options.lng) && exists(options.lat)
	}

	const initMap = () => {
		if (map) {
			return true
		}

		if (!mapRef.current) {
			return false
		}

		setMap(mapRef.current)
		mapRef.current.off('idle', 'travel-time', watchForRender)
		mapRef.current.on('idle', 'travel-time', watchForRender)

		return true
	}

	React.useEffect(() => {
		setCoordinates(null)

		if (!initMap()) {
			return
		}

		const enabled = (loading || rendering) && hasCoords()
		setEnabled(enabled)

		if (enabled) {
			setCoordinates({ lng: options.lng, lat: options.lat })
		}
	}, [loading, rendering, options])

	return (
		<>
			{enabled && <Marker 
	      longitude={coordinates.lng}
	      latitude={coordinates.lat}
	      anchor="center"
	      style={{
	      	width: "80px",
	      	height: "80px",
	      }}>
		      <div style={{
		      	width: "100%",
		      	height: "100%",
		      	backgroundImage: `url(./spinner.svg)`,
		      }} />
	     	</Marker>
	   	}
   	</>
	)
}
